import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default Route.extend({
  store: service("ember-store"),
  model(params) {
    let hash = this.modelFor("planbook")
    hash.lesson = get(this, "store").find("lesson", params.lesson_id)
    return hash(hash)
  },
})
